import { createRouter, createWebHistory } from "vue-router";

// Import your components
import Home from "./pages/home.vue";
import LoginPage from "./pages/LoginPage.vue";
import QuranPrograms from "./pages/quranPrograms.vue";
import QuranProgram from "./pages/quranProgram.vue";
import AboutUs from "./pages/aboutUs.vue";
import OurServices from "./pages/ourServices.vue";
import FrequentlyAskedQuestions from "./pages/FrequentlyAskedQuestions.vue";
import ContactUs from "./pages/ContactUs.vue";
import PrivacyPolicy from "./pages/PrivacyPolicy.vue";
import TermsAndConditions from "./pages/TermsAndConditions.vue";
import Application from "./pages/FurqanApplication.vue";
import LastNews from "./pages/LastNews.vue";

const routes = [
  { path: "/", component: Home },
  { path: "/login", component: LoginPage },
  { path: "/quran_programs", component: QuranPrograms },
  { path: "/quran_programs/:id",name: 'quran_program', component: QuranProgram },
  { path: "/about_us", component: AboutUs },
  { path: "/our_services", component: OurServices },
  { path: "/faq", component: FrequentlyAskedQuestions },
  { path: "/contact", component: ContactUs },
  { path: "/privacy_policy", component: PrivacyPolicy },
  { path: "/terms_and_conditions", component: TermsAndConditions },
  { path: "/application", component: Application },
  { path: "/last_news", component: LastNews },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior() {
    return { top: 0, behavior: "smooth" }; // Scroll to top smoothly
  },
});

export default router;
